import { motion } from "framer-motion";
import { Facebook, Instagram } from "lucide-react";
import Images from "../../utils/Images.jsx";

const XIcon = () => (
  <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current" aria-hidden="true">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

const Footer = () => {
  const socialLinks = [
    {
      icon: <Facebook className="w-5 h-5" />,
      href: "https://web.facebook.com/dealboxxpromo/",
      label: "Facebook",
    },
    { icon: <XIcon />, href: "https://x.com/dealboxx", label: "X" },
    {
      icon: <Instagram className="w-5 h-5" />,
      href: "https://www.instagram.com/dealboxxgh/",
      label: "Instagram",
    },
  ];

  return (
    <footer className="text-gray-800 bg-gray-50">
      <div className="px-4 py-12 mx-auto max-w-7xl sm:px-6 lg:px-8">
        {/* Main footer content - Centered */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="flex flex-col items-center text-center mb-8"
        >
          <div className="mb-6">
            <img
              src={Images.logo}
              alt="DealBoxx Logo"
              className="w-auto h-14 mx-auto"
            />
          </div>
          <p className="mb-8 max-w-2xl leading-relaxed text-gray-600 text-lg">
            The ultimate affiliate platform for promoters to earn commissions by
            sharing amazing deals with their audience.
          </p>

          {/* Social links */}
          <div className="flex gap-4 items-center mb-8">
            {socialLinks.map((social) => (
              <motion.a
                key={social.label}
                href={social.href}
                whileHover={{ scale: 1.1, y: -2 }}
                whileTap={{ scale: 0.95 }}
                className="w-12 h-12 bg-white hover:bg-[#FF7F7F] rounded-full flex items-center justify-center text-gray-600 hover:text-white transition-all duration-300 shadow-md hover:shadow-lg"
                aria-label={social.label}
              >
                {social.icon}
              </motion.a>
            ))}
          </div>
        </motion.div>

        {/* Bottom section - Copyright */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
          className="pt-8 border-t border-gray-300 text-center"
        >
          <div className="text-sm text-gray-600">
            © {new Date().getFullYear()} DealBoxx. All rights reserved.
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
